export class SharedConstants {
  static inputIdentifier = 'id';
}
